export default {"src":"/_next/static/media/menu-right.c3601a61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};